<template>
  <div>
    <div v-for="(plan) in planList" :key="plan.id" class="plan-item">
      <div class="title">
        <span>维修付款信息</span>
      </div>
      <FrameForm
          readonly
          component-param="bu_cs_task_pay_record"
          :init-ds-only="true"
          :init-data="plan"/>
    </div>
    <div v-for="(plan) in supplementList" :key="plan.id" class="plan-item">
      <div class="title">
        <span>{{ '补料编号：' + plan.id }}</span>
      </div>
      <FrameForm
          readonly
          component-param="bu_cs_task_pay_record"
          :init-ds-only="true"
          :init-data="plan"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "BuPayRecord",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      planList: [],
      supplementList: []
    }
  },
  async created() {
    let data = await this.$http('buCsTaskService.getPayRecord', {
      item_id: this.parentData.item_id
    });
    this.planList = data.plan_pay_list || []
    this.supplementList = data.supplement_pay_list || []
  },

}
</script>


<style scoped lang="less">

.trouble-form {
  padding: 10px 0 0 0;
  width: 700px;
}

.plan-item {
  border: 1px solid #ddd;
  margin-bottom: 10px;

  .title {
    background-color: #ddd;
    padding: 5px 0 5px 10px;
    font-weight: bold;
  }
}


</style>